import { TextField, TextFieldProps } from "@mui/material";
import "azure-maps-control/dist/atlas.min.css";
import { ChangeEvent } from "react";

import { GeoHelper } from "@/common/helpers/geo";
import { TypeHelper } from "@/common/helpers/type";

interface Props extends Omit<TextFieldProps, "type" | "inputMode" | "onChange"> {
  onChange?: (params: {
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    newValue: Nil<number>;
  }) => void;
}

export default function LongitudeInput({ label = "Longitude", onChange, ...otherProps }: Props) {
  return (
    <TextField
      label={label}
      type='text'
      inputMode='decimal'
      onChange={(e) => {
        const newValue =
          !TypeHelper.isNil(e.target.value) && !TypeHelper.isEmptyString(e.target.value)
            ? GeoHelper.clampLongitude(+e.target.value)
            : undefined;
        onChange &&
          onChange({
            e: e,
            newValue,
          });
      }}
      {...otherProps}
    />
  );
}
